var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "yxtbiz-flex-center" },
        [
          _c(
            "yxt-radio",
            {
              staticClass: "mr8",
              attrs: { label: 0, disabled: _vm.disabled },
              model: {
                value: _vm.type,
                callback: function ($$v) {
                  _vm.type = $$v
                },
                expression: "type",
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t(
                      "pc_kng_doc_support_html_lbl_picture" /** 图片模式 */
                    )
                  ) +
                  "\n    "
              ),
            ]
          ),
          _c(
            "yxt-button",
            {
              attrs: { type: "text" },
              on: {
                click: function ($event) {
                  return _vm.view(0)
                },
              },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.$t("pc_kng_doc_support_html_lbl_demo" /** 查看示例 */)
                )
              ),
            ]
          ),
        ],
        1
      ),
      _vm.type === 0 && _vm.showSize
        ? _c(
            "div",
            { staticClass: "ml24" },
            [
              _c(
                "div",
                { staticClass: "color-gray-7" },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "pc_kng_lbl_fontsizetips" /** 将文档转码为图片进行展示，为保证转码后文字的清晰度，请先确认原始文档字号大小 */
                        )
                      ) +
                      "\n      "
                  ),
                  _c(
                    "yxt-button",
                    {
                      attrs: { type: "text" },
                      on: {
                        click: function ($event) {
                          return _vm.view(2)
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("pc_kng_lbl_fontsizerefer" /** 字号对比图 */)
                        )
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "yxt-radio-group",
                {
                  attrs: { direction: "row" },
                  model: {
                    value: _vm.size_,
                    callback: function ($$v) {
                      _vm.size_ = $$v
                    },
                    expression: "size_",
                  },
                },
                [
                  _c("yxt-radio", { attrs: { label: 0 } }, [
                    _vm._v(_vm._s(_vm.$t("pc_kng_lbl_editfontsizenormal"))),
                    _c("span", { staticClass: "color-gray-7" }, [
                      _vm._v(
                        _vm._s(_vm.$t("pc_kng_lbl_editfontsizenormalcontent"))
                      ),
                    ]),
                  ]),
                  _c("yxt-radio", { attrs: { label: 1 } }, [
                    _vm._v(_vm._s(_vm.$t("pc_kng_lbl_editfontsizesmall"))),
                    _c("span", { staticClass: "color-gray-7" }, [
                      _vm._v(
                        _vm._s(_vm.$t("pc_kng_lbl_editfontsizesmallcontent"))
                      ),
                    ]),
                  ]),
                  _c("yxt-radio", { attrs: { label: 2 } }, [
                    _vm._v(_vm._s(_vm.$t("pc_kng_lbl_editfontsizemini"))),
                    _c("span", { staticClass: "color-gray-7" }, [
                      _vm._v(
                        _vm._s(_vm.$t("pc_kng_lbl_editfontsizeminicontent"))
                      ),
                    ]),
                  ]),
                  _vm.showSizeLimit
                    ? _c("yxt-radio", { attrs: { label: 3 } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "pc_kng_lbl_editfontsizelimit" /** 极限字体：以上字号都不清晰，选我 */
                            )
                          )
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "yxtbiz-flex-center mt10" },
        [
          _c(
            "yxt-radio",
            {
              staticClass: "mr8",
              attrs: { label: 1, disabled: _vm.disabled },
              model: {
                value: _vm.type,
                callback: function ($$v) {
                  _vm.type = $$v
                },
                expression: "type",
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t(
                      "pc_kng_doc_support_html_lbl_html" /** HTML模式（以Office文档形式展示，支持复制、搜索） */
                    )
                  ) +
                  "\n    "
              ),
            ]
          ),
          _c(
            "yxt-button",
            {
              attrs: { type: "text" },
              on: {
                click: function ($event) {
                  return _vm.view(1)
                },
              },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.$t("pc_kng_doc_support_html_lbl_demo" /** 查看示例 */)
                )
              ),
            ]
          ),
        ],
        1
      ),
      _vm.url
        ? _c("yxtbiz-image-viewer", {
            ref: "viewer",
            attrs: {
              "no-list": "",
              showNavbar: false,
              showToolbar: false,
              data: [{ url: _vm.url }],
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }